import { render } from "./submitAchievement.vue?vue&type=template&id=f40d58b6&scoped=true"
import script from "./submitAchievement.vue?vue&type=script&lang=js"
export * from "./submitAchievement.vue?vue&type=script&lang=js"

import "./submitAchievement.vue?vue&type=style&index=0&id=f40d58b6&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40d58b6"]])

export default __exports__